import { render, staticRenderFns } from "./EditCardiology.vue?vue&type=template&id=05224bc5&scoped=true"
import script from "./EditCardiology.vue?vue&type=script&lang=js"
export * from "./EditCardiology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05224bc5",
  null
  
)

export default component.exports